export default __webpack_public_path__ + "static/media/text.2acf7a8e.svg";